import React from 'react';

import { Box, Button } from '@mui/material';
import PropTypes from 'prop-types';

import { formsTestIds } from '../../../../forms.testIds';
import { getModeButtonSx, modeSelectorContainerSx } from '../../Signature.styles';

const SignatureModeSelector = ({
  isMultipleOptions,
  onSelectSingleMode,
  onSelectMultiOptionMode,
}) => (
  <Box data-testid={formsTestIds.IS_MULTIPLE_OPTIONS} role="tablist" sx={modeSelectorContainerSx}>
    <Button
      aria-selected={!isMultipleOptions}
      data-testid={formsTestIds.SIGNATURE_MODE_SINGLE_BUTTON}
      role="tab"
      size="small"
      sx={getModeButtonSx(!isMultipleOptions)}
      type="button"
      variant="text"
      onClick={onSelectSingleMode}
    >
      Single
    </Button>
    <Button
      aria-selected={isMultipleOptions}
      data-testid={formsTestIds.SIGNATURE_MODE_MULTI_BUTTON}
      role="tab"
      size="small"
      sx={getModeButtonSx(isMultipleOptions)}
      type="button"
      variant="text"
      onClick={onSelectMultiOptionMode}
    >
      Multi-option
    </Button>
  </Box>
);

SignatureModeSelector.propTypes = {
  isMultipleOptions: PropTypes.bool.isRequired,
  onSelectSingleMode: PropTypes.func.isRequired,
  onSelectMultiOptionMode: PropTypes.func.isRequired,
};

export default SignatureModeSelector;
